export const REGIONS = {
  EU: 'eu',
  US: 'us',
  AP: 'ap',
  UNKNOWN: 'unknown',
};

function defineRegionFromLocation(context) {
  let region;
  if (context.location.hostname.match(/(\.|^)us.?\./gm)) {
    region = REGIONS.US;
  } else if (context.location.hostname.match(/(\.|^)eu.?\./gm)) {
    region = REGIONS.EU;
  }
  return region;
}

function defineRegion(context) {
  const regionFromLocation = defineRegionFromLocation(context);

  if (regionFromLocation) {
    return regionFromLocation;
  }

  const { slug = '' } = context;

  if (slug.indexOf('-eu') > 0) {
    return REGIONS.EU;
  } /* this won't work for local signup app */ else if (slug.indexOf('-us') > 0) {
    return REGIONS.US;
  }

  return REGIONS.UNKNOWN;
}

export const region = defineRegion(window);
